import {IPriceCorrection} from '../../models/Price';

export const PRICE_CORRECTION = 'PRICE_CORRECTION';
export const PRICE_CORRECTION_SUCCESS = 'PRICE_CORRECTION_SUCCESS';
export const PRICE_CORRECTION_ERROR = 'PRICE_CORRECTION_ERROR';

export interface SavePriceCorrection {
  type: typeof PRICE_CORRECTION;
}

export interface SavePriceCorrectionSuccess {
  type: typeof PRICE_CORRECTION_SUCCESS;
  payload: IPriceCorrection;
}

export interface SavePriceCorrectionError {
  type: typeof PRICE_CORRECTION_ERROR;
}

export type PriceCorrectionActions =
  | SavePriceCorrection
  | SavePriceCorrectionSuccess
  | SavePriceCorrectionError;
